import store from '@/store'
import transverser from '@/helpers/transverser'

// Controla si para la url a la que estamos cambiando hay que mostrar o no los menus en caso de que la configuracion cargada sea con menus
export default (to, from, next) => {
  let showMenuRoute = !transverser.get('meta.hideMenus', false)(to)
  store.commit('app/SET_SHOW_MENUS', showMenuRoute)
  let showMinimalHeaderRoute = transverser.get('meta.showMinimalHeader', false)(to)
  store.commit('app/SET_SHOW_MINIMAL_HEADER', showMinimalHeaderRoute)
  return next()
}
